import {Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	margin: 0 auto;
	width: 100%;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('md')} {
		max-width: 600px;
	}
`;

export {StyledContainer};
